import * as React from "react";

/** Bottom nav mockExam icon (document with pencil) */
export const IconNavExam = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg width="1em" height="1em" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <mask id="mask0_nav_exam" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="28" height="28">
      <rect width="28" height="28" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_nav_exam)">
      <path
        d="M10 11V9H19V11H10ZM10 14V12H19V14H10ZM13 24H7C6.16667 24 5.45833 23.7083 4.875 23.125C4.29167 22.5417 4 21.8333 4 21V18H7V4H22V13.025C21.6667 12.9917 21.3292 13.0042 20.9875 13.0625C20.6458 13.1208 20.3167 13.225 20 13.375V6H9V18H15L13 20H6V21C6 21.2833 6.09583 21.5208 6.2875 21.7125C6.47917 21.9042 6.71667 22 7 22H13V24ZM15 24V20.925L20.525 15.425C20.675 15.275 20.8417 15.1667 21.025 15.1C21.2083 15.0333 21.3917 15 21.575 15C21.775 15 21.9667 15.0375 22.15 15.1125C22.3333 15.1875 22.5 15.3 22.65 15.45L23.575 16.375C23.7083 16.525 23.8125 16.6917 23.8875 16.875C23.9625 17.0583 24 17.2417 24 17.425C24 17.6083 23.9667 17.7958 23.9 17.9875C23.8333 18.1792 23.725 18.35 23.575 18.5L18.075 24H15ZM16.5 22.5H17.45L20.475 19.45L20.025 18.975L19.55 18.525L16.5 21.55V22.5ZM20.025 18.975L19.55 18.525L20.475 19.45L20.025 18.975Z"
        fill="currentColor"
      />
    </g>
  </svg>
);
